var map = {
	"./about.json": 7842,
	"./amr.json": 4303,
	"./cookie_policy.json": 4744,
	"./footer.json": 109,
	"./header.json": 5133,
	"./industry.json": 7784,
	"./inquiry.json": 1861,
	"./main.json": 7253,
	"./product.json": 3114,
	"./resource.json": 6408,
	"./solutions.json": 4488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5847;